import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  getDiscussion,
  createDiscussion,
  getUsers,
  clearUsers,
} from "../../actions/discussion";

import LoggedInNav from "../layout/IME/LoggedInNav";
import DiscussionInvites from "../layout/Innovators/DiscussionInvites";
import DiscussionUserItem from "../layout/Innovators/DiscussionUserItem";

const CreateDiscussion = ({
  match,
  auth: { user },
  discussion: { users, live_discussion },
  friend: { friends },
  isAuthenticated,
  getDiscussion,
  createDiscussion,
  getUsers,
  clearUsers,
}) => {
  const [discussion, setDiscussion] = useState({
    type: "1-on-1",
    description: "",
    invites: [],
  });
  const [keywordText, setKeyword] = useState("");
  const [keywordsText, setKeywords] = useState([]);
  const [textValue, setTextValue] = useState("");
  const [User, setUser] = useState({
    channelid: "",
    user: "",
    avatar: "",
    firstname: "",
    lastname: "",
    jobtitle: "",
    location: { city: "", state: "" },
  });

  const inputRefKeywords = useRef(null);

  useEffect(() => {
    getDiscussion(match.params.channelid);
  }, [match.params.channelid]);

  useEffect(() => {
    if (textValue !== "") {
      getUsers(textValue);
    }
  }, [textValue]);

  // if (!isAuthenticated || match.params.channelid !== user.channelid) {
  //   return <Redirect to="/" />;
  // }

  // if (
  //   isAuthenticated &&
  //   match.params.channelid === user.channelid &&
  //   live_discussion &&
  //   live_discussion.live
  // ) {
  //   return <Redirect to={`/liveonime/innovators/${user.channelid}/live`} />;
  // }

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <LoggedInNav />
      <div className="flex-all-content-fixed">
        <section className="banner-hero-alt">
          <div className="banner-section-name">
            <h1 className="large-font white">Create Discussion</h1>
          </div>
        </section>
        <section className="create-discussion-main-body">
          <div className="create-discussion-main">
            <div className="discussion-top-container">
              <div className="create-discussion-container">
                <div className="user-image">
                  <div className="large-avi-container">
                    <div className="avi-color-border green">
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                          user && user.avatar
                        }`}
                        className="large-avi"
                      />
                    </div>
                  </div>
                  <div className="large-avi-container">
                    <ul className="user-items">
                      <p className="user-online-item">
                        <span className="green name-font bold">
                          {user && user.channelid}
                        </span>
                      </p>
                      <li className="user-item">
                        {user && user.firstname} {user && user.lastname}
                      </li>
                      <li className="user-item">{user && user.jobtitle}</li>
                      <li className="user-item">
                        {user && user.location.city},{" "}
                        {user && user.location.state}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="select-container">
                  <label htmlFor="discussion-type" className="labels white">
                    *Select Discussion Type:
                  </label>
                  <select
                    className="discussion-select"
                    name="discussion"
                    required
                    value={discussion.type}
                    onChange={(e) => {
                      setDiscussion({ ...discussion, type: e.target.value });
                    }}
                  >
                    <option value="1-on-1">1-on-1 Discussion</option>
                    <option value="4-person">4 Person Panel Discussion</option>
                    <option value="group">Group Discussion</option>
                  </select>
                </div>
              </div>
              <label htmlFor="category" className="labels white">
                *Discussion Description:
              </label>
              <input
                type="text"
                name="description"
                className="discussion-input-style"
                placeholder="Enter Discussion Description"
                onChange={(e) =>
                  setDiscussion({ ...discussion, description: e.target.value })
                }
              />
            </div>
          </div>
          <div className="items-container">
            <div className="sub-section-container-alt">
              <div className="flex-only">
                <p className="sub-section green">Keywords</p>
              </div>
              <div className="input-label-container">
                <label htmlFor="keywords" className="labels-input green bold">
                  Enter a Keyword:
                </label>
                <input
                  type="text"
                  ref={inputRefKeywords}
                  name="keywords"
                  value={keywordText}
                  className="input-item"
                  placeholder="Enter a Keyword"
                  onChange={(e) => setKeyword(e.target.value)}
                />
                {keywordText !== "" && (
                  <div
                    className="add-keyword background-green"
                    onClick={() => {
                      setKeywords([...keywordsText, keywordText]);
                      setKeyword("");
                      inputRefKeywords.current.focus();
                    }}
                  >
                    Add Keyword
                  </div>
                )}
              </div>
              {keywordsText.map((word, index) => {
                return (
                  <li className="keywordsArray green" key={index}>
                    {word}
                    <i
                      className="fas fa-times fa-sm white times-sm mx-10"
                      onClick={() => {
                        keywordsText.splice(index, 1);
                        setKeywords([...keywordsText]);
                      }}
                    ></i>
                  </li>
                );
              })}
            </div>
          </div>
          <section className="friends-section">
            {discussion.invites && discussion.invites.length > 0 && (
              <section className="friends-section">
                <div className="user-section-name">
                  <i className="fas fa-vote-yea fa-2x mr-5 green"></i>
                  <p className="section-name">
                    Invited Users
                    <span className="mx-5 green"></span>
                  </p>
                </div>
                <div className="friend-results">
                  {discussion.invites &&
                    discussion.invites.map((invite, index) => {
                      return (
                        <DiscussionInvites
                          invite={invite}
                          key={index}
                          index={index}
                          discussion={discussion}
                          setDiscussion={setDiscussion}
                        />
                      );
                    })}
                </div>
              </section>
            )}
            <div className="label-input-container">
              <div className="input-drop-down">
                <form
                  className="search-input-hidden"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (textValue !== "") {
                      getUsers(textValue);
                    }
                    setTextValue("");
                  }}
                >
                  <input
                    className="search-input-style"
                    type="text"
                    name="messages"
                    value={textValue}
                    onChange={(e) => setTextValue(e.target.value)}
                    placeholder="Search here to invite users"
                  />
                  <button
                    className="search-button background-green"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (textValue !== "") {
                        getUsers(textValue);
                      }
                      setTextValue("");
                    }}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </form>
              </div>
            </div>
            {users && users.length > 0 ? (
              <section className="friends-section">
                <div className="user-section-name">
                  <i className="fas fa-users fa-2x mr-5 green"></i>
                  <p className="section-name">
                    Results
                    <span className="mx-5 green"></span>
                  </p>
                </div>
                <div className="friend-results">
                  {users &&
                    users.map((user) => {
                      return (
                        <DiscussionUserItem
                          user={user}
                          key={user.user}
                          clearUsers={clearUsers}
                          setUser={setUser}
                          User={User}
                          discussion={discussion}
                          setDiscussion={setDiscussion}
                        />
                      );
                    })}
                </div>
              </section>
            ) : (
              <div>
                <div className="user-section-name">
                  <i className="fas fa-users fa-2x mr-5 green"></i>
                  <p className="section-name">
                    Results
                    <span className="mx-5 green"></span>
                  </p>
                </div>
                <p className="empty-content-alt-dark green bold">
                  No Matched Results
                </p>
              </div>
            )}
          </section>
        </section>
        {discussion.description !== "" && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              createDiscussion(discussion, keywordsText);
            }}
            className="submit-changes"
          >
            <button className="submit-changes-button background-green">
              Create Discussion
            </button>
          </form>
        )}
      </div>
    </Fragment>
  );
};

CreateDiscussion.propTypes = {
  auth: PropTypes.object.isRequired,
  discussion: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  friend: PropTypes.object.isRequired,
  createDiscussion: PropTypes.func.isRequired,
  getDiscussion: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  clearUsers: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  discussion: state.discussion,
  profile: state.profile,
  friend: state.friend,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getDiscussion,
  createDiscussion,
  getUsers,
  clearUsers,
})(CreateDiscussion);
